import Footer from 'components/Footer'
import RootWrapper from 'pages/utils/RootWrapper'
import React from 'react'
import styled from 'styled-components'
import HyperCatCrying from './hypercat-crying.png'
import { ButtonPrimary } from 'components/Button'
import { LINKS } from 'constants/links'
import { Helmet } from 'react-helmet'

const MaintenanceWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  position: relative;
  padding: 16px;
`

const MaintenanceNote = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    font-family: 'unbounded';
  }

  p {
    font-size: 14px;
    text-align: center;
    color: ${({ theme }) => theme.text2};
    margin-bottom: 24px;
  }
  button {
    max-width: 200px;
  }
`

const ErrorPage = () => {
  return (
    <>
      <Helmet>
        <title>Error | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="An error has occured. We will be back online shortly to provide you with the best decentralized exchange experience."
        />
        <meta property="og:title" content="404 Error | HyperSwap Exchange on Hyperliquid" />
        <meta property="og:url" content={`${window.location.origin}`} />
      </Helmet>
      <RootWrapper>
        <MaintenanceWrapper>
          <MaintenanceNote>
            <img src={HyperCatCrying} alt="loading failed" style={{ width: '200px', borderRadius: '10000px' }} />
            <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#4afc38"
                strokeWidth="2"
                className="icon icon-tabler icons-tabler-outline icon-tabler-alert-triangle"
                style={{ verticalAlign: 'middle', marginRight: '6px' }}
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 9v4" />
                <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
                <path d="M12 16h.01" />
              </svg>
              Error Notice
            </h1>
            <p>
              We’re sorry, but an error has occurred, and you’ve landed on this page. <br />
              <br />
              Please let us know what actions you were performing before encountering this error by joining our Discord.{' '}
              <br />
              <br />
              While we work on resolving the issue, feel free to reach out to us on Discord for updates and to share
              more details about the error. Thank you for your understanding and patience!
            </p>
            <ButtonPrimary onClick={() => window.open(LINKS.discord.link, '_blank')}>Join Discord</ButtonPrimary>
          </MaintenanceNote>
        </MaintenanceWrapper>
      </RootWrapper>
      <Footer />
    </>
  )
}
export default ErrorPage
